/* tslint:disable:max-line-length */
import { SegmentSpecificMessages } from "../../types/types";

export const identityMessages: SegmentSpecificMessages = {
  emailExplanation: "Needed to send you your unique code",
  step: {
    personalInfo: {
      title: "Unlock Your Special Offer",
      subtitle: "Verify your current identity.",
      howDoesVerifyingWorkDetails:
        "To be eligible for this offer, you must have a valid driver license." +
        "<br><br>" +
        "{companyName} uses SheerID, a trusted partner, to verify your identity. SheerID only collects information that assists in verifying your eligibility. Additional information or documentation may be requested.",
      tryAgain: {
        title: "Check Your Name & other fields",
        subtitle: "Your information must match what is on your government-issued document(s).",
      },
      verifyingTitle: "Verifying your identity",
    },
    docUpload: {
      howDoesVerifyingWorkDetails:
        "Document review is handled by SheerID, a trusted partner who specializes in verifying identity." +
        "<br><br>" +
        "Documents are used only for verifying your current eligibility and will be permanently deleted after review is finalized.",
      uploadInstructions: "Upload a government-issued document that shows",
      title: "We need your driver license",
      subtitle:
        "Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.",
    },
    success: {
      title: "You've been verified",
      subtitle: "Here is your personal coupon code. It is unique to you and can only be used once.",
      redirectButtonText: "Use code now",
    },
  },
};
